import { useState } from "react";
import { Documentation } from "./documentation";
import Landing from "./landing";

export const Router = () => {
  // This is a very basic site; not worth implementing an entire router library
  // for this
  if (window.location.pathname == "/documentation") return <Documentation />;
  return <Landing />;
};
